// 本地环境配置
module.exports = {
  title: '万里长城',
  baseUrl: '', // 项目地址
  baseApi: '/api/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  APPID: '',
  APPSECRET: '',
  $cdn: ''
}
